import styled from 'styled-components';

import SearchIcon from '@material-ui/icons/Search';
import Datetime from 'react-datetime';
import Button from '../../../../../components/CustomButtons/Button';

import THEME from '../../../../../constants/theme';

export const ButtonSearchContainer = styled.div`
  margin-top: 6px;
`;

export const SearchButton = styled(Button)`
  border-radius: 8px !important;
  width: 116px;
  height: 48px;
  display: flex;
  align-items: center;
  font-family: Montserrat !important;
  font-style: normal !important;
  font-weight: 500 !important;
  font-size: 14px !important;
  line-height: 16px !important;
  text-transform: none !important;
`;

export const SearchStyledIcon = styled(SearchIcon)`
  width: 24px !important;
  height: 24px !important;
`;

export const DatetimeWrapper = styled(Datetime)`
  & .rdtPicker {
    margin-top: 26px !important;
  }
`;

export const ServiceSelector = styled.div`
  margin-top: 32px;
`;

export const SelectorTitle = styled.span`
  font-family: Montserrat;
  font-style: normal;
  font-weight: normal;
  font-size: 18px;
  line-height: 21px;
  color: ${THEME.bobBlack};
`;

export const ServiceDetails = styled.div`
  margin-top: 32px;
  border-top: 0.1px solid ${THEME.lightGrey};
`;

export const ServiceDetailsTitle = styled.div`
  margin-top: 32px;
  margin-bottom: 32px;
  font-family: Montserrat;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 19px;
  color: ${THEME.grey};
`;
